import Currency from "./Currency";
import BaseModel from "./BaseModel";
import Country from "./Country";
import Operator from "./Operator";
import { PricingAttributes } from "../attributes/pricing-attributes";
import PricingGroup from "./PricingGroup";
import { BaseAccountConfigurationAttributes } from "../attributes/base-account-conf-attributes";

class BaseAccountConfiguration {
  id: number;
  credit_base: number;
  assignment_date: string;

  currency: Currency;
  country: Country;
  pricing_group: PricingGroup;

  constructor(
    id: number,
    credit_base: number,
    assignment_date: string,

    currency: Currency,
    country: Country,
    pricing_group: PricingGroup
  ) {
    this.id = id;
    this.credit_base = credit_base;
    this.assignment_date = assignment_date;
    this.currency = currency;
    this.country = country;
    this.pricing_group = pricing_group;
  }

  static fromJson(
    json: BaseAccountConfigurationAttributes
  ): BaseAccountConfiguration | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new BaseAccountConfiguration(
      json.id,
      json.credit_base,
      json.assignment_date,
      json.currency != null ? Currency.fromJson(json.currency) : null,
      json.country != null ? Country.fromJson(json.country) : null,
      json.pricing_group != null
        ? PricingGroup.fromJson(json.pricing_group)
        : null
    );
  }
}

export default BaseAccountConfiguration;
